import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { style as stickyStyle } from "./Sticky.style";
const Sticky = ({ children, style: customStyle, onLayout }) => {
    const style = useMemo(() => stickyStyle(), []);
    const handleOnLayout = useCallback(({ nativeEvent: { layout: { width, height, x, y }, }, }) => onLayout?.({ width, height, x, y }), [onLayout]);
    return (React.createElement(View, { style: [style.sticky, customStyle], onLayout: handleOnLayout }, children));
};
export { Sticky };
